const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '线索账号ID',
      dataIndex: 'accountId',
      fixed: 'left',
      width: 200,
    },
    {
      title: '账号名称',
      dataIndex: 'accountName',
      width: 300,
    },
    {
      title: '渠道ID',
      dataIndex: 'channelId',
      // render: 'transTimes',
      width: 200,
    },
    {
      title: '渠道',
      dataIndex: 'channelName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '来源参数',
      dataIndex: 'sourceParams',
      width: 280,
      ellipsis: {
        showTitle: true,
        overlayInnerStyle: {
          width: 360,
          maxHeight: 200,
          overflowY: 'scroll'
        },
      },
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      width: 100,
    },
    {
      title: '线索ID',
      dataIndex: 'clueId',
      width: 200,
    },

    {
      title: '广告线索ID',
      dataIndex: 'adClueId',
      width: 300,
    },
    {
      title: '标单ID',
      dataIndex: 'otherId',
      width: 300,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 230,
    },
    {
      title: '入库失败原因',
      dataIndex: 'failReason',
      width: 200,
    },
    {
      title: '操作',
      render: 'actionTool',
      fixed: 'right',
      width: 146,
    },
  ],
  search: [
    {
      name: 'clueId',
      label: '线索ID',
      placeholder: '请输入',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      }
    },
    {
      name: 'channelId',
      label: '渠道ID',
      itemType: 'input',
      placeholder: '请输入',
    },
    {
      name: 'accountId',
      label: '线索账号ID',
      itemType: 'input',
      placeholder: '请输入',
    },
    {
      name: 'status',
      label: '状态',
      itemType: 'select',
      data: 'statusList',
      labelKey: 'description',
      key: 'key',
      allowClear: true,
      showSearch: true,
      events: ['filterOption:filterOption'],
    },
  ],
  footer: false,
}

export default config
